import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Loader } from '../components/UI'
import toast from 'react-hot-toast'

const Login: React.FC = () => {
  const { login, loginWithLink } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const linkToken = searchParams.get('token') || ''
  const autoLoginTried = useRef(false)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [linkError, setLinkError] = useState('')

  // ورود خودکار با لینک اختصاصی که مدیر ساخته است: /login?token=...
  useEffect(() => {
    if (!linkToken || autoLoginTried.current) return
    autoLoginTried.current = true

    const run = async () => {
      setLoading(true)
      try {
        await loginWithLink(linkToken)
        toast.success('خوش آمدید')
        navigate('/', { replace: true })
      } catch (err: any) {
        setLinkError(err?.response?.data?.message || err.message || 'لینک ورود نامعتبر یا منقضی شده است')
      } finally {
        setLoading(false)
      }
    }

    run()
  }, [linkToken, loginWithLink, navigate])

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await login(email, password)
      toast.success('خوش آمدید')
      navigate('/')
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err.message || 'خطا در ورود')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/favicon.svg" alt="" className="w-16 h-16 mx-auto mb-3" />
          <h1 className="text-2xl font-black text-white">پنل مدیریت طلا و نقره</h1>
          <p className="text-gray-400 text-sm mt-1">مدیریت قیمت خام، درصد سود، محصولات و سفارش‌ها</p>
        </div>

        <div className="card p-8">
          {linkToken ? (
            <div className="text-center py-4">
              {loading ? (
                <>
                  <div className="flex justify-center mb-4"><Loader /></div>
                  <p className="text-sm text-gray-600">در حال ورود با لینک اختصاصی…</p>
                </>
              ) : (
                <>
                  <div className="text-3xl mb-3">⚠️</div>
                  <p className="text-sm text-red-600 font-bold mb-1">ورود با لینک ممکن نشد</p>
                  <p className="text-xs text-gray-500 mb-4">{linkError || 'لینک ورود نامعتبر یا منقضی شده است'}</p>
                  <a href="/login" className="btn btn-primary w-full !py-3">ورود با ایمیل و رمز عبور</a>
                </>
              )}
            </div>
          ) : (
            <>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="label">ایمیل مدیر</label>
                  <input type="email" className="input" dir="ltr" placeholder="admin@goldsilver.ir" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div>
                  <label className="label">رمز عبور</label>
                  <input type="password" className="input" dir="ltr" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button className="btn btn-primary w-full !py-3 disabled:opacity-50" disabled={loading}>
                  {loading ? 'در حال ورود…' : 'ورود به پنل'}
                </button>
              </form>
              <p className="text-xs text-gray-400 mt-4 text-center">
                کاربر پیش‌فرض: admin@goldsilver.ir — رمز: Admin@12345
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Login